// Given a value to match and a options array, returns either the value of the matching option
// or the realValue.
// On filters sometimes is handy to differ the form option value used for form interaction purposes
// from the real value used for API and state interaction (i.e. you want to set a complex object
// or Array as value for an select option) for that reason we allow to use an extra attribute on
// form fields called realValue, that when present is used for state and API interactions instead of
// the default value. This helper allows to correctly retrieve that value from options if present.
export default (valueToMatch, options = []) => {
  const option = options.find(({ value }) => value === valueToMatch);

  return option?.realValue ?? option?.value ?? null;
};
